/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_5_Paragraphs_2Inputs */

const en_gc_search_guides_gridcraft_online_sections_5_paragraphs_2 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_5_Paragraphs_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For a longer session, save at meaningful checkpoints: after importing and checking a file, after making the main edits, and before closing or switching devices. This is a manual file workflow. Treat an open tab as a workspace, not a backup. If you need a continuously shared document with other editors, first choose a workflow designed for that requirement instead of forwarding this editor URL.`)
};

const zh_gc_search_guides_gridcraft_online_sections_5_paragraphs_2 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_5_Paragraphs_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`较长的编辑过程可以在关键节点保存：导入并检查文件后、主要修改完成后，以及关闭页面或切换设备前。这里采用手动文件流程，打开的标签页是工作区，不是备份。如果需要持续与他人共同编辑文档，应先选择支持该需求的流程，而不是直接转发编辑器网址。`)
};

/**
* | output |
* | --- |
* | "For a longer session, save at meaningful checkpoints: after importing and checking a file, after making the main edits, and before closing or switching devic..." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_5_Paragraphs_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_5_paragraphs_2 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_5_Paragraphs_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_5_Paragraphs_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_5_paragraphs_2(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_5_paragraphs_2(inputs)
});
export { gc_search_guides_gridcraft_online_sections_5_paragraphs_2 as "gc.search_guides.gridcraft_online.sections.5.paragraphs.2" }